import PageProtected from "../../../../components/Page/PageProtected"
import SectionPharmaGenes from "./Sections/SectionPharmaGenes";
import SectionDashboard from "../../../../components/Section/SectionDashboard";
import SectionDisclaimer from "../../../../components/Disclaimer/SectionDisclaimer";
import DisclaimerCardpgx from "./Sections/DisclaimerCardpgx";
import { useTheme } from "@mui/material";

export default function PgxWelcome() {
   
   const theme = useTheme();

    return (
    <>
    
    <PageProtected
    
      headline="PHARMACOGENETICS - " 
      specify ="PGx GENES"
         
      main={<>

      {theme.palette.mode === "light" ? (
      
         <SectionDashboard
            
            colorContainer="transparent"
      
            colorSection_1="grey.C400"
            Section_1={  <SectionPharmaGenes />}
      
            colorSection_2="grey.C100"
            Section_2={<SectionDisclaimer disclaimer={<DisclaimerCardpgx /> } />}
      
            colorSection_3="grey.C500"
            Section_3={"" }
      
          />
      
          ) :(
             
           <SectionDashboard
            
            colorContainer="transparent"
      
            colorSection_1="greydark.C600"
            Section_1={ <SectionPharmaGenes />}
      
            colorSection_2="greydark.C800"
            Section_2={<SectionDisclaimer disclaimer={<DisclaimerCardpgx /> } />} 
      
            colorSection_3="grey.C500"
            Section_3={"" }
          />
          )}
</>}
/>

</>
)}